import { atom } from 'jotai';

export const segmentPageOptionsAtom = atom<Record<string, unknown>>({});
